import ContentContainer from "Components/Container/ContentContainer";
import { BackButton, Button, Input } from "Components/CustomComponents";
import DeleteModal from "Components/Modals/DeleteModal";
import {
  useDeleteDriverMutation,
  useUpdateDriverMutation,
} from "Data/services/driversApi";
import { getErrorMessage } from "Hooks/useErrorHandler";
import { ErrorToast, SuccessToast } from "Hooks/useToast";
import { DriverFormData } from "Pages/AddDriver/AddDriver";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { EditProfileIcon } from "svg";
import styles from "./DriverProfile.module.scss";

const DriverProfile: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  console.log(id);
  const driver = location.state?.driver;
  // console.log(driver);

  const { handleSubmit, control, setValue } = useForm<DriverFormData>({});

  const [editable, setEditable] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  // const [shareModal, setShareModal] = useState<boolean>(false);

  useEffect(() => {
    if (driver) {
      setValue("firstname", driver.firstname);
      setValue("lastname", driver.lastname);
      setValue("username", driver.username);
      setValue("mobile_no", driver.mobile_no);
      setValue("truck_no", driver.truck_no);
    }
  }, [driver]);

  const handleEditable = () => {
    setEditable(!editable);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };

  // const handleShareModalOpen = () => {
  //   setShareModal(true);
  // };

  // const handleShareModalClose = () => {
  //   setShareModal(false);
  // };

  const [updateDriver, { isLoading }] = useUpdateDriverMutation();

  const handleProfile = async (data: DriverFormData) => {
    // console.log("handleProfile");
    // console.log(data);
    const formData: Pick<DriverFormData, "firstname" | "lastname"> = {
      firstname: data.firstname,
      lastname: data.lastname,
    };
    // console.log(formData);
    try {
      const response = await updateDriver(formData).unwrap();
      if (response.code !== 200) {
        ErrorToast(response.message);
      }
      if (response.code === 200) {
        SuccessToast(response.message);
        setEditable(false);
      }
    } catch (error) {
      // console.log("Driver Update Error:", error);
      ErrorToast(getErrorMessage(error));
    }
  };

  const [deleteDriver, { isLoading: deleteLoading }] =
    useDeleteDriverMutation();

  const handleDeleteAccount = async () => {
    const id = driver.id;
    try {
      const response = await deleteDriver({ id }).unwrap();
      if (response.code === 200) {
        navigate(-1);
        SuccessToast("Delete Driver Successfully.");
      }
    } catch (error) {
      // console.log("Driver Delete Error:", error);
      ErrorToast(getErrorMessage(error));
    }
  };

  return (
    <div className={styles.DriverProfile}>
      {deleteModal ? (
        <DeleteModal
          handleDeleteModalClose={handleDeleteModalClose}
          data={null}
          loading={deleteLoading}
          onDelete={handleDeleteAccount}
        />
      ) : null}

      {/* {shareModal ? (
        <ShareModal
          handleShareModalClose={handleShareModalClose}
          data={null}
          loading={deleteLoading}
          shareUrl={"http://github.com"}
        />
      ) : null} */}

      <BackButton isRelative={true} text="Driver Profile" classes="mb-1" />

      <ContentContainer
        bg="#ffffff"
        classes="d-flex justify-content-center p-4"
        style={{ borderRadius: "12px" }}
        hasBoxShadow={true}
      >
        <div className={`${styles.profileCard}`}>
          <Form onSubmit={handleSubmit(handleProfile)}>
            <div
              className={`${styles.editProfileBtn}`}
              onClick={handleEditable}
            >
              <EditProfileIcon />
              <span className="px-2">Edit Profile</span>
            </div>

            <div className="d-flex justify-content-center w-100 mb-5">
              <div className="position-relative mt-5 mt-sm-0">
                <img
                  alt=""
                  src={driver?.image_url}
                  width={"150px"}
                  height={"150px"}
                  className={`${styles.profileImage} rounded-circle`}
                />
                {/* <div className={`${styles.cameraBtn} rounded-circle `}>
                  <CameraIcon />
                </div> */}
              </div>
            </div>

            <Row className="gap-3 gap-md-0">
              <Col sm={12} md={6}>
                <Controller
                  control={control}
                  name="firstname"
                  render={({ field: { onChange, value } }) => (
                    <Input
                      classes={`${editable ? "" : "border-0"}`}
                      placeholder="First Name"
                      type="text"
                      value={value}
                      onChange={onChange}
                      disable={!editable}
                    />
                  )}
                />
              </Col>
              <Col sm={12} md={6}>
                <Controller
                  control={control}
                  name="lastname"
                  render={({ field: { onChange, value } }) => (
                    <Input
                      classes={`${editable ? "" : "border-0"}`}
                      placeholder="last Name"
                      type="text"
                      value={value}
                      onChange={onChange}
                      disable={!editable}
                    />
                  )}
                />
              </Col>
            </Row>

            <Controller
              control={control}
              name="mobile_no"
              render={({ field: { onChange, value } }) => (
                <PhoneInput
                  inputClass={`border-0`}
                  placeholder="Phone Number"
                  country={"us"}
                  value={value}
                  onChange={(phone) => onChange(phone)}
                  disabled={true}
                />
              )}
            />

            <Controller
              control={control}
              name="username"
              render={({ field: { onChange, value } }) => (
                <Input
                  classes={`border-0 my-3`}
                  style={{ cursor: "not-allowed" }}
                  placeholder="User Name"
                  type="text"
                  value={value}
                  onChange={onChange}
                  disable={true}
                  readOnly={true}
                />
              )}
            />
            {/* <Controller
              control={control}
              name="password"
              render={({ field: { onChange, value } }) => (
                <Input
                  classes={`${editable ? "" : "border-0"} my-3`}
                  placeholder="Password"
                  type="text"
                  value={value}
                  onChange={onChange}
                  disable={editable}
                />
              )}
            /> */}
            <Controller
              control={control}
              name="truck_no"
              render={({ field: { onChange, value } }) => (
                <Input
                  classes={`border-0 my-3`}
                  style={{ cursor: "not-allowed" }}
                  placeholder="Truck no"
                  type="text"
                  value={value}
                  onChange={onChange}
                  disable={true}
                  readOnly={true}
                />
              )}
            />

            {editable ? (
              <Row>
                <Col sm={12} md={12}>
                  <Button
                    text={
                      isLoading ? (
                        <Spinner animation="border" variant="light" size="sm" />
                      ) : (
                        "Save Profile"
                      )
                    }
                    className=" blackBg"
                    type={"submit"}
                  />
                </Col>
              </Row>
            ) : (
              <Row>
                <Col sm={12} md={12}>
                  <Button
                    onClick={handleDeleteModalOpen}
                    text={"Delete Profile"}
                    className=" redBtn"
                    type="button"
                  />
                </Col>
                {/* <Col sm={12} md={6}>
                  <Button
                    text={"Share Profile"}
                    className=" blackBg"
                    type="button"
                    onClick={handleShareModalOpen}
                  />
                </Col> */}
              </Row>
            )}
          </Form>
        </div>
      </ContentContainer>
    </div>
  );
};

export default DriverProfile;
